import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

export const TranscriptAI = () => {
  const { t } = useTranslation('components', { keyPrefix: 'transcript' });

  return (
    <Box
      sx={{
        position: 'absolute',
        backgroundColor: 'primary.main',
        borderRadius: 1,
        top: -10,
        right: 20,
        height: 20,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 80,
        color: 'grey.100',
      }}
    >
      <Typography variant="text3">{t('aiTitle')}</Typography>
    </Box>
  );
};
